// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { forwardRef } from "react";

export const Video = forwardRef(function CoreVideo(
  {
    src,
    poster,
    controls = false,
    autoPlay = false,
    muted = false,
    loop = false,
    preload = "metadata",
    sx,
    children,
    ...props
  },
  ref
) {
  return (
    <Box
      component="video"
      ref={ref}
      poster={poster}
      controls={controls}
      autoPlay={autoPlay}
      muted={muted}
      loop={loop}
      preload={preload}
      sx={{
        width: "100%",
        display: "block",
        ...sx,
      }}
      {...props}
    >
      {children || <source src={src} />}
    </Box>
  );
});

Video.propTypes = {
  src: PropTypes.string,
  poster: PropTypes.string,
  controls: PropTypes.bool,
  autoPlay: PropTypes.bool,
  muted: PropTypes.bool,
  loop: PropTypes.bool,
  preload: PropTypes.oneOf(["auto", "metadata", "none"]),
  sx: PropTypes.object,
};
